import useIntersectionObserver from '../../hooks/useIntersectionObserver/useIntersectionObserver';
import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';


// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const Image = ({ src, alt }) => {
  const controls = useAnimation();
  const [ref, isIntersecting] = useIntersectionObserver({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isIntersecting) {
      controls.start('visible');
    }
  }, [controls, isIntersecting]);

  const variants = {
    hidden: { clipPath: 'inset(0% 0% 100% 0%)' },
    visible: {
      clipPath: 'inset(0% 0% 0% 0%)',
      transition: { duration: 1, ease: 'easeInOut' }
    }
  };

  return (
    <div className={cn("wrapper")} ref={ref}>
      <div className={cn("container")}>
        <motion.div
          className={cn("image")}
          initial="hidden"
          animate={controls}
          variants={variants}
        >
          <img src={src} alt={alt} loading="lazy" decoding="async" />
        </motion.div>
      </div>
    </div>
  );
};

export default Image;